<template>
  <div class="nettdoc-medical-history">
    <h2 class="nettdoc-header nettdoc-medical-history__header">{{ $t('Medical history') }}</h2>

    <SectionHeader text="autoimmuneDisease" :required="true" :dark="true" />
    <TripleChoice
      :model="store.medicalHistory.autoimmuneDisease"
      v-on:action="value => store.addMedicalHistory('autoimmuneDisease', value)"
    />

    <SectionHeader text="hadSurgeryBefore" :required="true" :dark="true" />
    <TripleChoice
      :model="store.medicalHistory.hadSurgeryBefore"
      v-on:action="value => store.addMedicalHistory('hadSurgeryBefore', value)"
    />
    <template v-if="store.medicalHistory.hadSurgeryBefore === 'yes'">
      <SectionHeader text="hadSurgeryBeforeLocation" :required="false" :dark="true" />
      <Bodyparts 
        :model="store.medicalHistory.hadSurgeryBeforeLocation"
        v-on:action="value => store.addMedicalHistory('hadSurgeryBeforeLocation', value)"
      />
    </template>

    <SectionHeader text="Cardiovascular disease" :required="false" />

    <SectionHeader text="heartRythmDisorder" :required="false" :dark="true" />
    <TripleChoice
      :model="store.medicalHistory.cardiovascularDisease.heartRythmDisorder"
      v-on:action="value => store.addCardiovascularDiseaseHistory('heartRythmDisorder', value)"
    />

    <SectionHeader text="tachcardia" :required="false" :dark="true" />
    <TripleChoice
      :model="store.medicalHistory.cardiovascularDisease.tachcardia"
      v-on:action="value => store.addCardiovascularDiseaseHistory('tachcardia', value)"
    />
    <Dropdown
      v-if="store.medicalHistory.cardiovascularDisease.tachcardia === 'yes'"
      label="please choose"
      :data="['Always', 'suddenly']"
      :choice="store.medicalHistory.cardiovascularDisease.tachcardiaSince"
      v-on:action="value => store.addCardiovascularDiseaseHistory('tachcardiaSince', value)"
    />

    <SectionHeader text="extrasystole" :required="false" :dark="true" />
    <TripleChoice
      :model="store.medicalHistory.cardiovascularDisease.extrasystole"
      v-on:action="value => store.addCardiovascularDiseaseHistory('extrasystole', value)"
    />

    <SectionHeader text="heartPaceMaker" :required="false" :dark="true" />
    <TripleChoice
      :model="store.medicalHistory.cardiovascularDisease.heartPaceMaker"
      v-on:action="value => store.addCardiovascularDiseaseHistory('heartPaceMaker', value)"
    />

    <SectionHeader text="takingMedicine" :required="false" :dark="true" />
    <TripleChoice
      :model="store.medicalHistory.cardiovascularDisease.takingMedicine"
      v-on:action="value => store.addCardiovascularDiseaseHistory('takingMedicine', value)"
    />

    <SectionHeader text="highBloodPressure" :required="false" :dark="true" />
    <TripleChoice
      :model="store.medicalHistory.cardiovascularDisease.highBloodPressure"
      v-on:action="value => store.addCardiovascularDiseaseHistory('highBloodPressure', value)"
    />

    <SectionHeader text="cardiovascularObliteration" :required="false" :dark="true" />
    <TripleChoice
      :model="store.medicalHistory.cardiovascularDisease.cardiovascularObliteration"
      v-on:action="value => store.addCardiovascularDiseaseHistory('cardiovascularObliteration', value)"
    />

    <SectionHeader text="hadSurgery" :required="false" :dark="true" />
    <TripleChoice
      :model="store.medicalHistory.cardiovascularDisease.hadSurgery"
      v-on:action="value => store.addCardiovascularDiseaseHistory('hadSurgery', value)"
    />



    <SectionHeader text="Metabolism disorder" :required="false" />

    <SectionHeader text="diabetes" :required="false" :dark="true" />
    <TripleChoice
      :model="store.medicalHistory.metabolismDisorder.diabetes"
      v-on:action="value => store.addMetabolismDisorderHistory('diabetes', value)"
    />

    <SectionHeader text="pills" :required="false" :dark="true" />
    <TripleChoice
      :model="store.medicalHistory.metabolismDisorder.pills"
      v-on:action="value => store.addMetabolismDisorderHistory('pills', value)"
    />

    <SectionHeader text="insulinInjections" :required="false" :dark="true" />
    <TripleChoice
      :model="store.medicalHistory.metabolismDisorder.insulinInjections"
      v-on:action="value => store.addMetabolismDisorderHistory('insulinInjections', value)"
    />

    <SectionHeader text="thyroidGlandDisorder" :required="false" :dark="true" />
    <TripleChoice
      :model="store.medicalHistory.metabolismDisorder.thyroidGlandDisorder"
      v-on:action="value => store.addMetabolismDisorderHistory('thyroidGlandDisorder', value)"
    />

    <SectionHeader text="bloodCoagulationDisfunction" :required="false" :dark="true" />
    <TripleChoice
      :model="store.medicalHistory.metabolismDisorder.bloodCoagulationDisfunction"
      v-on:action="value => store.addMetabolismDisorderHistory('bloodCoagulationDisfunction', value)"
    />

    <SectionHeader text="allergicReactionToMedicaments" :required="false" :dark="true" />
    <TripleChoice
      :model="store.medicalHistory.metabolismDisorder.allergicReactionToMedicaments"
      v-on:action="value => store.addMetabolismDisorderHistory('allergicReactionToMedicaments', value)"
    />

    <SectionHeader text="otherAllergies" :required="false" :dark="true" />
    <TripleChoice
      :model="store.medicalHistory.metabolismDisorder.otherAllergies"
      v-on:action="value => store.addMetabolismDisorderHistory('otherAllergies', value)"
    />

    <SectionHeader text="Do you have a tumorous disease/cancer?" :required="false" :dark="true" />
    <TripleChoice
      :model="store.medicalHistory.metabolismDisorder.tumorOrCancer"
      v-on:action="value => store.addMetabolismDisorderHistory('tumorOrCancer', value)"
    />

    <SectionHeader text="chemotherapy" :required="false" :dark="true" />
    <TripleChoice
      :model="store.medicalHistory.metabolismDisorder.chemotherapy"
      v-on:action="value => store.addMetabolismDisorderHistory('chemotherapy', value)"
    />

    <SectionHeader text="radiationTherapy" :required="false" :dark="true" />
    <TripleChoice
      :model="store.medicalHistory.metabolismDisorder.radiationTherapy"
      v-on:action="value => store.addMetabolismDisorderHistory('radiationTherapy', value)"
    />

    <SectionHeader text="arthrosis" :required="false" :dark="true" />
    <TripleChoice
      :model="store.medicalHistory.metabolismDisorder.arthrosis"
      v-on:action="value => store.addMetabolismDisorderHistory('arthrosis', value)"
    />

    <SectionHeader text="rheumatism" :required="false" :dark="true" />
    <TripleChoice
      :model="store.medicalHistory.metabolismDisorder.rheumatism"
      v-on:action="value => store.addMetabolismDisorderHistory('rheumatism', value)"
    />

    <SectionHeader text="chronicalInflammatoryIntestine" :required="false" :dark="true" />
    <TripleChoice
      :model="store.medicalHistory.metabolismDisorder.chronicalInflammatoryIntestine"
      v-on:action="value => store.addMetabolismDisorderHistory('chronicalInflammatoryIntestine', value)"
    />

    <SectionHeader text="colitis" :required="false" :dark="true" />
    <TripleChoice
      :model="store.medicalHistory.metabolismDisorder.colitis"
      v-on:action="value => store.addMetabolismDisorderHistory('colitis', value)"
    />

    <SectionHeader text="morbusCrohn" :required="false" :dark="true" />
    <TripleChoice
      :model="store.medicalHistory.metabolismDisorder.morbusCrohn"
      v-on:action="value => store.addMetabolismDisorderHistory('morbusCrohn', value)"
    />

    <SectionHeader text="pulmonaryDisease" :required="false" :dark="true" />
    <TripleChoice
      :model="store.medicalHistory.metabolismDisorder.pulmonaryDisease"
      v-on:action="value => store.addMetabolismDisorderHistory('pulmonaryDisease', value)"
    />

    <SectionHeader text="chronicalPulmonaryDisease" :required="false" :dark="true" />
    <TripleChoice
      :model="store.medicalHistory.metabolismDisorder.chronicalPulmonaryDisease"
      v-on:action="value => store.addMetabolismDisorderHistory('chronicalPulmonaryDisease', value)"
    />

    <SectionHeader text="asthma" :required="false" :dark="true" />
    <TripleChoice
      :model="store.medicalHistory.metabolismDisorder.asthma"
      v-on:action="value => store.addMetabolismDisorderHistory('asthma', value)"
    />


    <SectionHeader text="Infectious disease" :required="false" />

    <SectionHeader text="hiv" :required="false" :dark="true" />
    <TripleChoice
      :model="store.medicalHistory.infectiousDisease.hiv"
      v-on:action="value => store.addInfectiousDiseaseHistory('hiv', value)"
    />

    <SectionHeader text="viralHepatitis" :required="false" :dark="true" />
    <TripleChoice
      :model="store.medicalHistory.infectiousDisease.viralHepatitis"
      v-on:action="value => store.addInfectiousDiseaseHistory('viralHepatitis', value)"
    />

    <SectionHeader text="syphilis" :required="false" :dark="true" />
    <TripleChoice
      :model="store.medicalHistory.infectiousDisease.syphilis"
      v-on:action="value => store.addInfectiousDiseaseHistory('syphilis', value)"
    />

    <SectionHeader text="tuberculosis" :required="false" :dark="true" />
    <TripleChoice
      :model="store.medicalHistory.infectiousDisease.tuberculosis"
      v-on:action="value => store.addInfectiousDiseaseHistory('tuberculosis', value)"
    />

    <SectionHeader text="cholera" :required="false" :dark="true" />
    <TripleChoice
      :model="store.medicalHistory.infectiousDisease.cholera"
      v-on:action="value => store.addInfectiousDiseaseHistory('cholera', value)"
    />

    <SectionHeader text="varicella" :required="false" :dark="true" />
    <TripleChoice
      :model="store.medicalHistory.infectiousDisease.varicella"
      v-on:action="value => store.addInfectiousDiseaseHistory('varicella', value)"
    />

    <SectionHeader text="measles" :required="false" :dark="true" />
    <TripleChoice
      :model="store.medicalHistory.infectiousDisease.measles"
      v-on:action="value => store.addInfectiousDiseaseHistory('measles', value)"
    />

    <SectionHeader text="rubella" :required="false" :dark="true" />
    <TripleChoice
      :model="store.medicalHistory.infectiousDisease.rubella"
      v-on:action="value => store.addInfectiousDiseaseHistory('rubella', value)"
    />

    <SectionHeader text="diphteria" :required="false" :dark="true" />
    <TripleChoice
      :model="store.medicalHistory.infectiousDisease.diphteria"
      v-on:action="value => store.addInfectiousDiseaseHistory('diphteria', value)"
    />

    <SectionHeader text="typhus" :required="false" :dark="true" />
    <TripleChoice
      :model="store.medicalHistory.infectiousDisease.typhus"
      v-on:action="value => store.addInfectiousDiseaseHistory('typhus', value)"
    />



    <SectionHeader text="substanceConsume" :required="true" />
    <CheckboxList 
      :data="['Alcohol', 'Nicotine / tabacco', 'Other drugs / medicaments', 'I consume drugs (also THC/Cannabis)', 'No', 'I don\'t know']"
      :choice="store.medicalHistory.substanceConsume"
      v-on:action="value => store.addSubstanceConsume(value)"
    />

    <Button 
      :text="edit ? 'Update' : 'Submit'"
      :active="store.medicalHistoryComplete"
      v-on:action="submit"
    />
  </div>
</template>

<script>
import { observer } from "mobx-vue";
import store from "../store/store";

import SectionHeader from '../components/SectionHeader'
import TripleChoice from '../components/TripleChoice'
import YesNo from '../components/YesNo'
import Button from '../components/Button'
import CheckboxList from '../components/CheckboxList'
import Dropdown from '../components/Dropdown'
import Bodyparts from '../components/Bodyparts'
export default observer({
  name: 'MedicalHistory',
  data() {
    return {
      store: store
    }
  },
  props: {
    edit: Boolean
  },
  components: {
    SectionHeader, YesNo, Button, TripleChoice, CheckboxList, Dropdown, Bodyparts
  },
  created() {
    this.store.persistMedicalHistory()
  },
  methods: {
    submit: function() {
      localStorage.setItem(
        "medicalHistory",
        JSON.stringify(this.store.medicalHistory)
      )
      if (this.edit) {
        this.$emit('close')
      } else {
        this.$router.push(`/${this.$i18n.locale}/nettdoctor/summary`)
      }
    }
  }
})
</script>

<style lang="scss" scoped>
.nettdoc-medical-history {
  position: absolute;
  width: 100%;
  background-color: #ffffff;
  &__header {
    margin: 10px 0;
  }
}
</style>